import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ bookingData, onClose }) => {
  // Use the actual booking ID from backend
  const bookingRef = bookingData.bookingId || 'SKI-PENDING';
  
  // Check if booking is within 48 hours
  const isUrgentBooking = () => {
    if (!bookingData.selectedDates || bookingData.selectedDates.length === 0) return false;
    
    const firstLessonDate = new Date(bookingData.selectedDates[0]);
    const now = new Date();
    const hoursDifference = (firstLessonDate - now) / (1000 * 60 * 60);
    
    return hoursDifference < 48;
  };
  
  const urgentBooking = isUrgentBooking();
  
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <div className="success-icon">
            ✓
          </div>
          <h2 className="modal-title">
            Rezervare Confirmată!
          </h2>
        </div>
        
        <div className="modal-body">
          <div className="confirmation-message">
            <p>
              Mulțumim pentru rezervare! Am trimis un email de confirmare la adresa:
            </p>
            <p className="email-highlight">
              <a href={`mailto:${bookingData.contactEmail}`}>{bookingData.contactEmail}</a>
            </p>
          </div>
          
          <div className="booking-reference">
            <p className="reference-label">
              Codul dvs. de rezervare:
            </p>
            <div className="reference-code">
              {bookingRef}
            </div>
            <p className="reference-note">
              Vă rugăm să păstrați acest cod pentru referințe viitoare
            </p>
          </div>
          
          {urgentBooking && (
            <div className="urgent-notice">
              <div className="urgent-icon">⚠️</div>
              <div className="urgent-content">
                <h3 className="urgent-title">Rezervare în mai puțin de 48 de ore!</h3>
                <p className="urgent-text">
                  Deoarece ați selectat o lecție în următoarele 48 de ore, vă rugăm să ne contactați urgent telefonic pentru confirmare rapidă:
                </p>
                <a href="tel:+40744686913" className="urgent-phone">
                  📞 +40 744 686 913
                </a>
                <p className="urgent-note">
                  Suntem disponibili zilnic pentru a confirma rapid disponibilitatea instructorului.
                </p>
              </div>
            </div>
          )}
          
          <div className="next-steps">
            <h3 className="next-steps-title">📋 Pașii următori:</h3>
            <ul className="steps-list">
              <li>
                Veți primi un email de confirmare în câteva minute
              </li>
              {urgentBooking ? (
                <li>
                  <strong>Contactați-ne telefonic urgent la <a href="tel:+40744686913">+40 744 686 913</a></strong> pentru confirmare rapidă
                </li>
              ) : (
                <li>
                  Vă vom contacta în 24 de ore pentru confirmare finală
                </li>
              )}
              {bookingData.paymentMethod === 'cash' && (
                <li>
                  Plata se va efectua în numerar la prima lecție
                </li>
              )}
              {bookingData.paymentMethod === 'online' && (
                <li>
                  Verificați emailul pentru detalii plată online
                </li>
              )}
            </ul>
          </div>
          
          <div className="contact-info">
            <p className="contact-text">
              <strong>Pentru întrebări sau modificări:</strong>
              <br />
              <a href="tel:+40744686913">📞 +40 744 686 913</a>
              <br />
              <a href="mailto:m_adi_i@yahoo.com">📧 m_adi_i@yahoo.com</a>
            </p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button 
            className="btn-close-modal"
            onClick={onClose}
          >
            Închide
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;